import React, { useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useFitInViewport } from "@react/shared/ui/DropdownMenu"
import IconButton from "@react/shared/ui/IconButton"

const Popover = ({ rect, width = 320, title, subtitle, onClose, children, footer }) => {
  const panelRef = useRef(null)
  const placed   = useFitInViewport(panelRef, { top: rect.bottom + 6, left: rect.left, flipBottom: rect.top - 6 })

  useEffect(() => {
    const onKey   = event => { if (event.key === "Escape") onClose() }
    const onPress = event => { if (panelRef.current && !panelRef.current.contains(event.target)) onClose() }
    document.addEventListener("keydown", onKey)
    // Deferred so that the click which opened the popover does not close it.
    const timer = setTimeout(() => document.addEventListener("mousedown", onPress), 0)
    return () => {
      clearTimeout(timer)
      document.removeEventListener("keydown", onKey)
      document.removeEventListener("mousedown", onPress)
    }
  }, [onClose])

  return createPortal(
    <div
      ref={panelRef}
      style={{ top: placed.top, left: placed.left, width }}
      className="pp-float fixed z-[1200] bg-white border border-slate-200 rounded-xl shadow-lg font-sans text-[13px]"
      onMouseDown={event => event.stopPropagation()}
    >
      {(title || subtitle) && (
        <div className="flex items-start gap-2 px-4 pt-3 pb-2.5 border-b border-slate-100">
          <div className="min-w-0 flex-1">
            {title && <div className="text-[13.5px] font-semibold text-slate-900 truncate">{title}</div>}
            {subtitle && <div className="text-[11.5px] text-slate-500 mt-0.5 truncate">{subtitle}</div>}
          </div>
          <IconButton size="sm" onClick={onClose} title={I18n.t("project_planning.actions.close")}>
            <FontAwesomeIcon icon="xmark" />
          </IconButton>
        </div>
      )}
      <div className="px-4 py-3">{children}</div>
      {footer && <div className="flex items-center gap-2 px-4 py-2.5 border-t border-slate-100 bg-slate-50/60 rounded-b-xl">{footer}</div>}
    </div>,
    document.body,
  )
}

export default Popover
